<template>
    <v-select hide-details :items="games" item-text='name' item-value='id' label="Game" v-model="selectedGames" v-on:input="this.updateParent" multiple clearable>
      <template v-slot:prepend-item>
        <v-list-item ripple @click="toggle">
          <v-list-item-action>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template slot="item" slot-scope="{ parent, item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-action>
            <v-checkbox v-model="attrs.inputValue" @change="parent.$emit('select', item)"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{item.name}}</v-list-item-title>
            <v-list-item-subtitle class="pb-2">Playing: {{item.count}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
</template>

<script>
export default {
  name: 'GameSelect',
  props: {
    games: {
      type: Array, // String, Number, Boolean, Function, Object, Array
      required: true,
      default: null
    }
  },
  computed: {
    allSelected () {
      return this.selectedGames.length === this.games.length
    },
    someSelected () {
      return this.selectedGames.length > 0 && !this.allSelected
    },
    icon () {
      if (this.allSelected) return 'mdi-checkbox-marked'
      if (this.someSelected) return 'mdi-checkbox-intermediate'
      return 'mdi-checkbox-blank-outline'
    }
  },
  data () {
    return {
      selectedGames: []
    }
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.allSelected) {
          this.selectedGames = []
        } else {
          this.selectedGames = this.games.map(g => g.name)
        }
        this.updateParent(this.selectedGames)
      })
    },
    updateParent(s) {
      this.$emit('input', s)
    },
  }
}
</script>

<style>
</style>
